import React from "react";
import { Link } from "react-router-dom";

export default function AppFooter({
  variant = "landing",
  logoSrc,
}) {
  const year = new Date().getFullYear();

  if (variant === "dashboard") {
    return (
      <footer
        className="w-full shrink-0 border-t border-[#EB6AB5]/20 bg-[#11111f] px-4 py-4 text-center text-sm text-gray-400"
        style={{
          position: "static",
          width: "100%",
          height: "auto",
          minHeight: "0",
          maxHeight: "none",
          overflow: "visible",
          inset: "auto",
          margin: 0,
          flex: "0 0 auto",
        }}
      >
        <nav
          aria-label="Dashboard footer navigation"
          className="flex flex-wrap justify-center gap-6"
        >
          <Link
            to="/privacy-cookie"
            className="underline underline-offset-4 transition hover:text-[#EB6AB5]"
          >
            Privacy &amp; Cookie Policy
          </Link>

          <Link
            to="/terms-conditions"
            className="underline underline-offset-4 transition hover:text-[#EB6AB5]"
          >
            Terms &amp; Conditions
          </Link>
        </nav>

        <p className="mt-2 text-xs text-gray-500">
          Reignite.Spirit Ltd — Abu Dhabi Global Market
          (ADGM), UAE
        </p>

        <p className="mt-1 text-xs text-gray-500">
          © {year} Reignite Spirit. All rights reserved.
        </p>
      </footer>
    );
  }

  return (
    <footer
      className="w-full shrink-0 border-t border-slate-800 bg-[#0d0d1b]"
      style={{
        position: "static",
        width: "100%",
        height: "auto",
        minHeight: "0",
        maxHeight: "none",
        overflow: "visible",
        inset: "auto",
        margin: 0,
        padding: 0,
        flex: "0 0 auto",
      }}
    >
      <div
        className="mx-auto flex w-full max-w-7xl flex-col items-center justify-between gap-6 px-4 py-8 sm:px-6 sm:py-10 lg:px-8 md:flex-row"
        style={{
          position: "static",
          height: "auto",
          minHeight: "0",
          maxHeight: "none",
          overflow: "visible",
        }}
      >
        <div className="flex items-center gap-3">
          {logoSrc && (
            <img
              src={logoSrc}
              alt="Reignite Spirit logo"
              className="h-10 w-10 object-contain drop-shadow-[0_0_12px_#eb6fbd]"
              width="40"
              height="40"
            />
          )}

          <div>
            <p className="text-lg font-semibold tracking-wide text-[#EB6AB5]">
              REIGNITE.SPIRIT
            </p>

            <p className="text-xs uppercase tracking-[0.15em] text-[#EB6AB5]/70">
              Rekindle Purpose
            </p>
          </div>
        </div>

        <nav
          aria-label="Footer navigation"
          className="flex flex-wrap justify-center gap-6 text-sm text-gray-400"
        >
          <Link
            to="/privacy-cookie"
            className="underline underline-offset-4 transition hover:text-[#EB6AB5]"
          >
            Privacy &amp; Cookie Policy
          </Link>

          <Link
            to="/terms-conditions"
            className="underline underline-offset-4 transition hover:text-[#EB6AB5]"
          >
            Terms &amp; Conditions
          </Link>

          <Link
            to="/disclaimer"
            className="underline underline-offset-4 transition hover:text-[#EB6AB5]"
          >
            Disclaimer
          </Link>
        </nav>

        <div className="text-center md:text-right">
          <p className="text-sm text-white/50">
            Reignite.Spirit Ltd — Abu Dhabi Global Market
            (ADGM), UAE
          </p>

          <p className="mt-1 text-sm text-slate-600">
            © {year} Reignite Spirit. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}